__turbopack_context__.v({
  "file-item": "FileUploadField-module-scss-module__GQNHqq__file-item",
  "file-item__delete": "FileUploadField-module-scss-module__GQNHqq__file-item__delete",
  "file-item__name": "FileUploadField-module-scss-module__GQNHqq__file-item__name",
  "file-item__size": "FileUploadField-module-scss-module__GQNHqq__file-item__size",
  "file-list": "FileUploadField-module-scss-module__GQNHqq__file-list",
  "file-upload": "FileUploadField-module-scss-module__GQNHqq__file-upload",
  "file-upload--dragging": "FileUploadField-module-scss-module__GQNHqq__file-upload--dragging",
  "file-upload--error": "FileUploadField-module-scss-module__GQNHqq__file-upload--error",
  "file-upload__description": "FileUploadField-module-scss-module__GQNHqq__file-upload__description",
  "file-upload__descriptions": "FileUploadField-module-scss-module__GQNHqq__file-upload__descriptions",
  "file-upload__heading": "FileUploadField-module-scss-module__GQNHqq__file-upload__heading",
});
